import React, {useEffect} from "react";
import {Helmet} from 'react-helmet';

import {Button, Grid, Hidden,} from "@material-ui/core";

import {Add as AddIcon} from "@material-ui/icons";

import {Centered, Paper, Typography,} from "../../../../common/components/libs";
import NoMenus from "./NoMenus";
import {FadeInOutVertical} from "../../../../common/components/Animated";
import {observer} from "mobx-react";
import {useStores} from "../../../../hooks";
import {MenuFormType} from "../../store/generalMenuStore/forms";
import MenuComponent from "./components/MenuComponent";
import {useTranslation} from "react-i18next";
import EditMenuForm from "./components/forms/EditMenuForm";
import TariffExpiresForm from './components/forms/TariffExpiresForm';


const MenusListPage = () => {
    const { generalStore, generalMenuStore, authStore } = useStores();
    const { showTariffPopUp } = authStore
    const {t, ready} = useTranslation(["general", "menu"], { useSuspense: false });
    useEffect(() => {
        const HeaderButton = () => {
            return <>
                <Hidden smDown>
                    <Button variant="contained" color="primary"
                            onClick={() => {
                                generalMenuStore.forms.showPopupForm(MenuFormType.createMenu)
                            }}>
                        <AddIcon/>
                        {t("general:create")}
                    </Button>

                </Hidden>
                <Hidden mdUp>
                    <Paper p={5}>
                        <Typography variant={'h5'}>
                            {t("menu:menusList.menu.createNewMenu")}
                        </Typography>
                        <Typography variant={'body2'} color={'textSecondary'} mb={2}>
                            {t("menu:menusList.menu.menuConsist")}
                        </Typography>
                        <Button variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => {
                                    generalMenuStore.forms.showPopupForm(MenuFormType.createMenu)
                                }}>
                            <AddIcon/>
                            {t("general:create")}
                        </Button>
                    </Paper>
                </Hidden>
            </>
        };
        generalStore.setPageTitle(t("menu:menusList.menu.myMenus"), <HeaderButton/>);
        generalMenuStore.fetchMenus();
    }, [generalMenuStore, generalStore, ready]);

    useEffect(() => {
        authStore.setShowTariffPopUp(false)
        if (showTariffPopUp && !authStore.isTariffAlive()) {
            generalMenuStore.forms.showPopupForm(MenuFormType.tariffExpiresForm, authStore.organizationBranch?.activeTariffDetails)
        }
    }, [authStore])

    const content = [];
    const menus = generalMenuStore.menusList;

    if (menus.length > 0) {
        content.push(
            <FadeInOutVertical show={true} key="content">
                <Grid container spacing={4}>
                    {
                        menus.map(item => <MenuComponent item={item} key={item.id}/>)
                    }
                </Grid>
            </FadeInOutVertical>
        )
    } else {
        content.push(
            <Centered key="noContent">
                <NoMenus/>
            </Centered>
        )
    }
    return (
        <>
            <Helmet title={t("menu:menusList.menu.yourMenus")}/>
            <TariffExpiresForm/>
            {content}
            <EditMenuForm/>
        </>
    );


};

export default observer(MenusListPage);
